import { apiGetUserLogin_sh, apiGetUserLogin_sg } from '@/api/insurance';
import md5 from 'js-md5';
import { isProduct } from '@utils/flag';
import { isiOS, isAndroid, bridgeUtils } from '@/utils/bridge.js';
import sha1 from './sha1';
import { Toast, Dialog } from 'vant';
import store from '@/store';
import router from '@/router'
const env = process.env.VUE_APP_ENV === 'production' ? 'production' : 'dev'
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};

export async function userInfoAuth(mobile = '', verifyCode = '') {

  const pageType = store.state.base.pageType
  const openId = localStorage.getItem('insure_openId');


  if (pageType == 'insure_suggest') {
    //   商管
    let data = {
      mobile,
      verifyCode,
      openId,
      type: mobile ? 2 : 3,
    };
    for (const key in data) {
      if (!data[key]) {
        delete data[key];
      }
    }
    let res = await apiGetUserLogin_sg(data);
    console.log('***sg***', res);
    if (res.status != 200) {
      Toast(res.message);
      window.location.href = `${location.origin}${location.pathname}#/insure_login`;
      return
    }
    if (!res.data?.token) {
      // 未绑定
      window.location.href = `${location.origin}${location.pathname}#/insure_login`;
    } else {

      let base = encodeURIComponent(
        JSON.stringify({
          token: res.data.token,
          userId: res.data.userIdToken,
          plazaId: res.data.plazaId,
          plazaName: res.data.plazaName,
          storeId: res.data.storeId,
        })
      );
      let payload = encodeURIComponent(
        JSON.stringify({
          type: res.data.type,
          userIdToken: res.data.userId,
          sign: res.data.sign,
        })
      );
      window.location.href = `${location.origin}${location.pathname}#/wxAuth/insure_share?base=${base}&payload=${payload}`;

    }
  } else {
    // 商户
    let data = {
      openId,
      deviceType: isiOS ? 1 : 2,
      mobile,
      verifyCode,
      // type: type == 'auth' ? 5 : 2,
      type: 5,
    };
    for (const key in data) {
      if (!data[key]) {
        delete data[key];
      }
    }
    let res = await apiGetUserLogin_sh(data);
    if (res.status != 200) {
      Toast(res.message);
    }
    if (!res.data?.token) {
      // 未绑定
      window.location.href = `${location.origin}${location.pathname}#/insure_login`;
    } else {
      let base = encodeURIComponent(
        JSON.stringify({
          token: res.data.token,
          userId: res.data.userId,
          plazaId: res.data.plazaId,
          plazaName: res.data.plazaName,
          storeId: res.data.storeId,
        })
      );
      localStorage.removeItem('insure_shareInfo')
      if (pageType == 'share') {
        let params = {
          shareId: localStorage.getItem('shareId') || '',
          shareType: localStorage.getItem('shareRoleType') || '',
          shareSquareId: localStorage.getItem('sharePlazaId') || '',
          media: pageTypeConfig['insure_suggest'].media,
          personnelId: res.data.userId
        };
        // const shareId = localStorage.getItem('shareId') || ''
        // const shareRoleType = localStorage.getItem('shareRoleType') || ''
        // const sharePlazaId = localStorage.getItem('sharePlazaId') || ''
        const md5key = insure_url_config[env].md5key
        const wdSign = localStorage.getItem('wdSign') || ''
        if (md5(md5key + params.shareId + params.shareType + params.shareSquareId) == wdSign) {
          // console.log('******', md5key + params.shareId + params.shareType + params.shareSquareId + params.personnelId);
          params.wdSign = md5(md5key + params.shareId + params.shareType + params.shareSquareId + params.personnelId)
          const url = LinkPage('/index', params)
          console.log('********shareurl***************', url);
          // window.location.replace(url)
          localStorage.setItem('insure_shareInfo', JSON.stringify({
            shareId: params.shareId,
            shareType: params.shareType,
            shareSquareId: params.shareSquareId,
            personnelId: params.personnelId,
            wdSign: params.wdSign
          }))
          let href = `${location.origin}${location.pathname}#/wxAuth/insure_n_index?base=${base}`
          window.location.replace(href)

        } else {
          Dialog.alert({
            message: '二维码错误',
            showConfirmButton: false,
          }).then(() => { });
        }
      } else {


        if (pageType == 'myBill' || pageType == 'myPay') {
          window.location.href = `${location.origin}${location.pathname}#/wxAuth/insure_linkPage?base=${base}`;
        } else if (pageType == 'insure_n_index') {
          // window.location.href = `${location.origin}${location.pathname}#/wxAuth/insure_changeStore?base=${base}`;
          // window.location.href = `${location.origin}${location.pathname}#/wxAuth/insure_n_index?base=${base}`;
          window.location.replace(`${location.origin}${location.pathname}#/wxAuth/insure_n_index?base=${base}`)
          // router.replace({
          //   path:'/wxAuth/insure_n_index',
          //   query:{
          //     base,
          //   }
          // })
        } else {
          console.log(`${location.origin}${location.pathname}#/wxAuth/insure_changeStore?base=${base}`);
          window.location.href = `${location.origin}${location.pathname}#/wxAuth/insure_changeStore?base=${base}`;
        }
      }
    }
  }
}

export const pageTypeConfig = {
  myInsure: {
    name: '本店保险',
    path: '/insure_main',
    url: '',
  },
  myBill: {
    name: '我的保单',
    path: '/insure_linkPage',
    url: '/insureList',
  },
  myPay: {
    name: '我的理赔',
    path: '/insure_linkPage',
    url: '',
  },
  insure_public: {
    name: '公众责任险',
    path: '/insure_linkPage',
    url: 'insure_public',
    caseCode: 'QX000000131284',
  },
  insure_money: {
    name: '财产一切险',
    path: '/insure_linkPage',
    url: 'insure_money',
    caseCode: 'QX000000131283',
  },
  insure_project: {
    name: '工程保险',
    path: '/insure_linkPage',
    url: 'insure_project',
    caseCode: 'QX000000131279',
  },
  insure_anything: {
    name: '施工人员意外险',
    path: '/insure_linkPage',
    url: 'insure_anything',
    caseCode: 'QX000000131280',
  },
  insure_suggest: {
    name: '推荐保险',
    path: '/',
    url: '',
    // media: '14904'
    media: isProduct() ? '14904' : '510'
  },
  insure_index: {
    name: '保险首页',
    path: '/',
    url: '',
    media: isProduct() ? '14904' : '510'
  },
  insure_operating: {
    name: '经营期保险',
    path: '/insure_linkPage',
    url: 'insure_operating',
    // media: '515',
    media: isProduct() ? '14906' : '510'

  },
  insure_building: {
    name: '施工期保险',
    path: '/insure_linkPage',
    url: 'insure_building',
    // media: '515',
    media: isProduct() ? '14905' : '510'
  },
  insure_service: {
    name: '服务商保险',
    path: '/insure_linkPage',
    url: 'insure_service',
    // media: '515',
    media: isProduct() ? '14909' : '510'
  },
  insure_worker_owner: {
    name: '商户专属员工意外险',
    path: '/insure_linkPage',
    url: 'insure_worker_owner',
    caseCode: 'GI000000000276',
  },
};

export function wxSign(jsapi_ticket, url) {
  var createNonceStr = function () {
    // return Math.random()
    //   .toString(36)
    //   .substr(2, 15);
    return '13579246';
  };

  var createTimestamp = function () {
    return parseInt(new Date().getTime() / 1000) + '';
  };

  var raw = function (args) {
    var keys = Object.keys(args);
    keys = keys.sort();
    var newArgs = {};
    keys.forEach(function (key) {
      newArgs[key.toLowerCase()] = args[key];
    });

    var string = '';
    for (var k in newArgs) {
      string += '&' + k + '=' + newArgs[k];
    }
    string = string.substr(1);
    return string;
  };

  /**
   * @synopsis 签名算法
   *
   * @param jsapi_ticket 用于签名的 jsapi_ticket
   * @param url 用于签名的 url ，注意必须动态获取，不能 hardcode
   *
   * @returns
   */
  // var sign = function(jsapi_ticket, url) {
  //   var ret = {
  //     jsapi_ticket: jsapi_ticket,
  //     nonceStr: createNonceStr(),
  //     timestamp: createTimestamp(),
  //     url: url,
  //   };
  //   var string = raw(ret);
  //   let shaObj = new jsSHA(string, 'TEXT');
  //   ret.signature = shaObj.getHash('SHA-1', 'HEX');

  //   return ret;
  // };

  var ret = {
    jsapi_ticket: jsapi_ticket,
    nonceStr: createNonceStr(),
    timestamp: createTimestamp(),
    url: url,
  };
  var string = raw(ret);
  return sha1(string);
}

export const insure_url_config = {
  dev: {

    // // 内网测试
    // base_url: 'https://pre-testapi.xiebao18.com/dispatch/cps',
    // md5key: 'TNM2EzOWMyNjBjNDg11031003',
    // partnerId: '11031003',
    // partnerUniqKey: '11031003',

    // // 内网正式
    // base_url: 'https://pre-api.xiebao18.com/dispatch/cps',
    // md5key: 'ONOGEzODYyNmMyOTc11031003',
    // partnerId: '11031003',
    // partnerUniqKey: '11031003',


    // 测试
    // base_url: 'https://testapi.xiebao18.com/dispatch/cps',
    // md5key: 'TNMzlkZjliYjJiYTd2154158',
    // partnerId: '2154158',
    // partnerUniqKey: '2154158',
    base_url: 'https://pre-testapi.xiebao18.com/dispatch/cps',
    md5key: 'TNM2EzOWMyNjBjNDg11031003',
    partnerId: '11031003',
    partnerUniqKey: '11031003',


  },
  production: {
    // 生产
    base_url: 'https://api.xiebao18.com/dispatch/cps',
    md5key: 'ONZWNiODYzNzZmNmQ2154158',
    partnerId: '2154158',
    partnerUniqKey: '2154158',

    // 内网
    // base_url: 'https://pre-testapi.xiebao18.com/dispatch/cps',
    // md5key: 'TNM2EzOWMyNjBjNDg11031003',
    // partnerId: '11031003',
    // partnerUniqKey: '11031003',

  },
};

export function LinkPage(url, ...params) {
  let partnerId =
    insure_url_config[env].partnerId;
  let partnerUniqKey =
    insure_url_config[env].partnerUniqKey;
  let base_url = insure_url_config[env].base_url,
    sign = md5(
      insure_url_config[env].md5key + partnerId
    ),
    href = '',
    // 1H5、2PC、3iOS、4Android、5微信小程序
    platform = '1';
  if (localStorage.getItem('mini_token')) {
    platform = '5'
  } else if (isWechat()) {
    platform = '1';
  } else if (isiOS) {
    platform = '3'
  } else if (isAndroid) {
    platform = '4'
  }

  console.log(platform);

  let query = params[0];
  let data = {
    partnerId,
    partnerUniqKey,
    platform,
    sign,
    ...query,
  };

  href = `${base_url}${url}?${queryString(data)}`;
  return href;
}

export function queryString(params) {
  let paramsArr = [];
  for (const key in params) {
    paramsArr.push(`${key}=${params[key]}`);
  }
  let paramsString = paramsArr.join('&');
  return paramsString;
}
